import {
    GET_NOMINATED_DATA_OBJECT_MERGE_PREVIEW_SUCCESS,
    GET_NOMINATED_DATA_OBJECT_MERGE_PREVIEW_FAILURE,
} from "./actions";

const initialState = {
    getNominatedDataObjectMergePreviewResult: {
        success: true
    },
    nominatedDataObjectMergePreview: {
        record: null,
        schema: null,
        // What the confidence gate would do with this merge: { held, reason, fieldIds },
        // { held: false }, or { unknown: true }; null when the service did not say.
        gate: null
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_NOMINATED_DATA_OBJECT_MERGE_PREVIEW_SUCCESS:
            return {
                ...state,
                getNominatedDataObjectMergePreviewResult:
                {
                    success: true
                },
                nominatedDataObjectMergePreview:
                {
                    record: action.payload.record,
                    schema: action.payload.schema,
                    gate: action.payload.gate || null
                }
            };
        case GET_NOMINATED_DATA_OBJECT_MERGE_PREVIEW_FAILURE:
            return {
                ...state,
                getNominatedDataObjectMergePreviewResult:
                {
                    success: false,
                    ...action.payload.error
                },
                nominatedDataObjectMergePreview:
                {
                    record: null,
                    schema: null,
                    gate: null
                }
            };
        default:
            return state;
    }
};
